import { connect, useSelector, useDispatch } from 'react-redux';
import { getIsVerificationNeeded } from '../publicSession/selectors';
import { useCallback } from 'react';
import { pushVerificationPopup } from './actions';
import noop from '../utils/noop';
import { useRestrictToLoggedIn } from '../utils/hooks/useRestrictToLoggedIn';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
const mapStateToProps = (state)=>({
        isVerificationNeeded: getIsVerificationNeeded(state)
    });
const mapDispatchToProps = {
    pushVerificationPopup
};
export function withVerification(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component); // redux types are not fond of generics
}
export function useVerification() {
    const isVerificationNeeded = useSelector(getIsVerificationNeeded);
    const { isLoggedIn, sendUserToJoinPage } = useRestrictToLoggedIn();
    const dispatch = useDispatch();
    const pushVerificationPopupCallback = useCallback((actionType)=>yieldToMain(()=>{
            dispatch(pushVerificationPopup(actionType));
        }), [
        dispatch
    ]);
    const restrictToVerified = useCallback((actionType, callback = noop)=>()=>yieldToMain(()=>{
                isVerificationNeeded ? pushVerificationPopupCallback(actionType) : callback();
            }), [
        pushVerificationPopupCallback,
        isVerificationNeeded
    ]);
    const restrictToVerifiedAndLoggedIn = useCallback((restrictedActionName, actionType, callback = noop)=>()=>yieldToMain(()=>{
                isLoggedIn ? isVerificationNeeded ? pushVerificationPopupCallback(actionType) : callback() : sendUserToJoinPage(restrictedActionName);
            }), [
        isLoggedIn,
        isVerificationNeeded,
        pushVerificationPopupCallback,
        sendUserToJoinPage
    ]);
    return {
        isVerificationNeeded,
        pushVerificationPopup: pushVerificationPopupCallback,
        restrictToVerified,
        restrictToVerifiedAndLoggedIn
    };
}

//# sourceMappingURL=withVerification.js.map